import moment from 'moment';
import { COUNTRY } from '../../../constants';
export const validateDateFilter = (toDate, fromDate) => {
    if (toDate && fromDate) {
        if (moment(toDate) < moment(fromDate)) {
            return { validationFlag: false, validationMessage: 'To date cannot be greater than from date' }
        } else {
            return { validationFlag: true, validationMessage: '' }
        }
    } else {
        return { validationFlag: false, validationMessage: '' }
    }
}

export const getCountries = () => {
    const tempCountries = [];
    COUNTRY.forEach(data => {
        tempCountries.push({value: 'country', label: data.countryName})
    });
    return tempCountries;
}